import {useContext, useState} from "react";
import ClientAxios from "../../Client.axios";
import {useNavigate} from "react-router-dom";
import {AppContext} from "../../Context/MainContext";
import Layout from "../../Layout/Layout.component";
import Swal from "sweetalert2";

const SettingsPage = () => {

    const [data, setData] = useState({
        companyID: "" ,
        companyPW: "" ,
        representativeID: "" ,
        representativePW: "" ,
    });

    const { selectedProject } = useContext(AppContext);
    const navigate = useNavigate();

    const Save = async (e: React.FormEvent) => {
        e.preventDefault();

        const client = ClientAxios.getInstance();

        const updatedProject = {
            _id: selectedProject._id,
            credentials: data,
        };

        const response = await client.updateProjects(updatedProject);
        if (response.error) {
            console.error("Error updating credentials:", response.error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Hubo un error al guardar la información.",
            });
        } else {
            console.log("Credentials updated successfully");
            Swal.fire({
                icon: "success",
                title: "Guardado",
                text: "Información guardada correctamente.",
            });
        }
    };

    return (
        <Layout>
            <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-r px-4 relative">
                {/* Heading */}
                <h1 className="mb-6 font-bold text-center max-w-lg">
                Por favor inserte el rut y la contraseña del SII del Representante legal y de la Empresa
                </h1>
        
                {/* Container with relative to position note */}
                <div className="relative w-full max-w-3xl flex justify-center">
                {/* Form box centered */}
                <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md z-10">
                    <form onSubmit={Save}>
                    {/* form inputs (same as before) */}
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="representativeID">
                        Rut Representante Legal
                        </label>
                        <input
                        type="text"
                        id="representativeID"
                        placeholder="12345678-9"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) => setData({ ...data, representativeID: e.target.value })}
                        value={data.representativeID}
                        />
                    </div>
                    {/* Other inputs */}
                    <div className="mb-6">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="representativePW">
                        Contraseña Representante Legal
                        </label>
                        <input
                        type="password"
                        id="representativePW"
                        placeholder="********"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) => setData({ ...data, representativePW: e.target.value })}
                        value={data.representativePW}
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="companyID">
                        Rut Empresa
                        </label>
                        <input
                        type="text"
                        id="companyID"
                        placeholder="12345678-9"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) => setData({ ...data, companyID: e.target.value })}
                        value={data.companyID}
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="companyPW">
                        Contraseña Empresa
                        </label>
                        <input
                        type="password"
                        id="companyPW"
                        placeholder="********"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) => setData({ ...data, companyPW: e.target.value })}
                        value={data.companyPW}
                        />
                    </div>
                    <div className="flex items-center justify-between">
                        <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        >
                        Guardar
                        </button>
                    </div>
                    </form>
                </div>
        
                {/* Note positioned absolutely on right */}
                <div className="hidden md:block absolute top-0 right-[-150px] w-64 bg-yellow-100 border border-yellow-300 text-yellow-800 p-4 rounded-lg text-sm shadow">
                    <h2 className="font-bold mb-2">Importante</h2>
                    <p>
                        Para tener informacion acerca de las facturas, notas de creditos y guias de despacho se necesitan las credenciales del representante Legal.
                        Para tener informacion acerca de las boletas se necesitan las credenciales de la empresa
                    </p>
                </div>
                </div>
            </div>
        </Layout>
    );
}

export default SettingsPage;